import { gql } from '@apollo/client'
import { USER_FRAGMENT } from '../fragments'

export const CREATE_STORE_GROUP = gql`
  mutation StoreGroupName($input: CreateStoreGroupInput!) {
    createStoreGroup(input: $input) {
      storeGroup {
        id
        name
        parentGroup {
          name
        }
        groupType
        storeList {
          name
        }
        assignedTo {
          ...User
        }
        region {
          name
        }
      }
    }
  }
  ${USER_FRAGMENT}
`
